export default __webpack_public_path__ + "static/media/p-card.ea2023be.png";